import { Link } from "wouter";

const COMPARISON_GUIDE_PATH = "/ai-search-ppc-agencies-london-comparison/";

export default function AISearchPpcAgenciesGuideLink() {
  return (
    <section className="mt-10 rounded-xl border border-[#00D4AA]/25 bg-[#0b1725] p-5 text-white sm:p-6" aria-labelledby="ai-search-ppc-agencies-guide-link">
      <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-[#00D4AA]">London agency comparison</p>
      <h2 id="ai-search-ppc-agencies-guide-link" className="font-serif text-xl">
        AI Search and PPC Agencies in London: 6 Verified Options
      </h2>
      <p className="mt-2 max-w-2xl text-sm leading-relaxed text-slate-300">
        Review six alphabetically presented providers using public evidence of London presence, AI-search capability and paid-search scope-then compare ownership and measurement before choosing.
      </p>
      <Link href={COMPARISON_GUIDE_PATH} className="mt-4 inline-flex text-sm font-semibold text-[#00D4AA] hover:text-teal-200">
        Compare the six public-evidence options →
      </Link>
    </section>
  );
}
